import React, { useState } from "react";
import ErrataDisplay from "/src/helpers/components/errataDisplay.jsx";
import CancelledStampOverlay from "/src/helpers/components/cancelledStampOverlay.jsx";

const HomepageAdhocRow = ({ item }) => {
    // Details open by default: for an item-only booking (weddings, ad hoc extras) the details ARE
    // the booking, and "Show full itinerary" then "Details" was one step more than the old site.
    const [expanded, setExpanded] = useState(true);
    const isCancelled = item?.cancelled === true;

    const startDate = item.start ? new Date(item.start) : null;
    const isValidDate = startDate && startDate.getFullYear() > 1;
    const hasSubDescription = item.subDescription && item.subDescription.trim().length > 0;
    const hasErratas = item.erratas && item.erratas.length > 0;

    const formatDate = (date) =>
        date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

    const renderSubDescription = (text) => {
        const lines = text.split("\n");
        const elements = [];
        let currentList = [];

        const flushList = () => {
            if (currentList.length > 0) {
                elements.push(
                    <ul key={`ul-${elements.length}`} className="list-disc list-inside space-y-1 text-sm text-content_2">
                        {currentList.map((li, i) => (
                            <li key={i}>{li}</li>
                        ))}
                    </ul>
                );
                currentList = [];
            }
        };

        lines.forEach((line, i) => {
            const trimmed = line.trim();
            if (trimmed.startsWith("* ") || trimmed.startsWith("- ")) {
                currentList.push(trimmed.substring(2));
            } else if (trimmed === "") {
                flushList();
            } else {
                flushList();
                elements.push(
                    <p key={`p-${i}`} className="text-sm text-content_2">{trimmed}</p>
                );
            }
        });

        flushList();
        return elements;
    };

    return (
        <div className={`relative rounded-card shadow-card ${(hasSubDescription || hasErratas) ? "px-8 pt-6 pb-2" : "px-8 py-6"} ${isCancelled ? "bg-red-50 border border-red-200" : "bg-white"}`}>
            {isCancelled && <CancelledStampOverlay />}
            <div className="flex flex-wrap items-center gap-2 mb-3">
                <div className="text-emp">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                </div>
                <span className="text-sm font-semibold text-content_2 uppercase tracking-wide">Extra</span>
                {isValidDate && (
                    <span className="text-sm text-content_2 ml-auto">{formatDate(startDate)}</span>
                )}
                {item.extRef && (
                    <span className="text-xs font-medium text-content_2 basis-full">Supplier Ref: {item.extRef}</span>
                )}
            </div>

            <p className="text-sm font-medium text-primary">{item.description}</p>

            {hasSubDescription && (
                <>
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className="flex items-center gap-2 mt-3 pt-3 border-t border-content_5 w-full text-left cursor-pointer"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-content_3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-sm font-medium text-content_2">Details</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`h-4 w-4 text-content_3 ml-auto transition-transform duration-200 ${expanded ? "rotate-180" : ""}`}
                            fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                    {expanded && (
                        <div className="mt-3 space-y-2">
                            {renderSubDescription(item.subDescription)}
                        </div>
                    )}
                </>
            )}

            {hasErratas && (
                <div className="mt-4 pt-3 border-t border-content_5">
                    <ErrataDisplay erratas={item.erratas} />
                </div>
            )}
        </div>
    );
};

export default HomepageAdhocRow;
